import { Component, OnInit } from '@angular/core';
import { ReportService } from '../../service/report.service';
import { NotifierService } from 'angular-notifier';
import { RepoApiService } from '../../service/repo-api.service';

@Component({
  selector: 'app-moving-topline',
  templateUrl: './moving-topline.component.html',
  styleUrls: ['./moving-topline.component.scss']
})
export class MovingToplineComponent implements OnInit {

  public copyOrMoveType:string;
  public studyDetailsContainer:any[] = [];
  public selectedStudy:'';
  constructor(
    public reportService: ReportService,
    public notifier: NotifierService,
    public repoService:RepoApiService
  ) { }

  ngOnInit(): void {
    this.copyOrMoveType = 'keepCopy';
    this.getAllStudy();
  }


  ngOnDestroy(){
    this.closemovingToplineComponent();
    this.selectedStudy = "";
    this.copyOrMoveType = 'keepCopy';
  }


  getAllStudy(){
    let query = {no_pagination :true};
    this.reportService.getUploadData(query,'allstudy').subscribe((res:any)=>{
      this.studyDetailsContainer = res.data;
    });

  }



  moveFileFunction(){
    if(!this.selectedStudy || this.selectedStudy == ''){
      this.notifier.notify('error','Please Select Study');
    }else{
      let body = {file_id:this.reportService.movingToplineFileDetails.file_uuid,study_id:this.selectedStudy};
      body['keep_original'] = this.copyOrMoveType === 'keepCopy' ? true : false;
      this.repoService.moveFile(body).subscribe(result =>{
        if(result['status'] == 1){
          this.notifier.notify('success','File move successfully');
          this.reportService.getRepositoryDetail(this.reportService.studyId);
          let query = {"page":1,"page_size":20}
          this.reportService.getRepositoryFilesPagination(this.reportService.studyId,query);
        }else{
          this.notifier.notify("error","Something went wrong!")
        }
      })
    }
    this.closemovingToplineComponent();
  }






  closemovingToplineComponent(){
    this.reportService.isMovingFileComponent = false;
    this.selectedStudy = "";
    this.copyOrMoveType = 'keepCopy';
  }


  assignLength(file: any){
    if (file.length < 5) {
      return 43;
    }
    else if (file.length == 5) {
      return 40;
    }
    else if (file.length > 5 && file.length <= 10) {
      return 35;
    }
    return 30;
  }

}
